import { gql } from '@apollo/client'

export const NETWORKS_COMPANIES_COUNTRIES_YEARS = gql`
  query NetworksCompaniesCountriesYears {
    networksCompaniesCountriesYears {
      networkId
      networkName
      companies {
        companyId
        companyName
        companyCountries {
          legalEntityId
          legalEntityName
          country
          years
        }
      }
    }
  }
`
